import Button from "@acko-tech/building-blocks.ui.button-old";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled, { css } from "styled-components";
import React from "react";

type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  mStyles?: object;
  dWebStyles?: object;
}

export const Container = styled(Flex) <ContainerProps>`
  width: 100%;
  border-radius: 12px;
  border: 1px solid #efe9fb;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  height: auto;
  box-sizing: border-box;
  ${(props) => props.dWebStyles ? css(props.dWebStyles as TemplateStringsArray) : ""}
  @media (max-width: 768px) {
    ${(props) => props.mStyles ? css(props.mStyles as TemplateStringsArray) : ""}
  }
`;

export const CardHeadingText = styled(Text)`
  color:  #040222;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.1px;
`;

export const InfoButton = styled.button`
  color: #36354c;
  text-align: right;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.1px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  border: none;
  background: none;
`;
